import { SharedModule } from '../../shared/shared.module';
import { AssociationsComponent } from './associations.component';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AssociationNewComponent } from './association-new/association-new.component';
import { AssociationCerfaDownloadComponent} from './association-cerfa-download/association-cerfa-download.component';
import { AssociationsDetailsModule } from './associations-details/associations-details.module';
import { AssociationsListModule } from './associations-list/associations-list.module';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BsDatepickerModule } from 'ngx-bootstrap';
import { ImageCropperModule } from 'ngx-image-cropper';
import { AssociationsLandingModule } from './association-landing/association-landing.module';

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    NgbModule,
    ImageCropperModule,
    SharedModule,
    BsDatepickerModule,
    AssociationsDetailsModule,
    AssociationsLandingModule,
    AssociationsListModule
  ],
  declarations: [AssociationsComponent, AssociationNewComponent, AssociationCerfaDownloadComponent],
  exports: [AssociationsComponent],
  entryComponents: [AssociationNewComponent, AssociationCerfaDownloadComponent]
})
export class AssociationsModule { }
